import { render, staticRenderFns } from "./GreenButtonDataImportModal.vue?vue&type=template&id=1f258842&scoped=true&"
import script from "./GreenButtonDataImportModal.vue?vue&type=script&lang=js&"
export * from "./GreenButtonDataImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f258842",
  null
  
)

export default component.exports